app.controller('OversluitController', ['$http', '$log', '$filter', '$scope','$window', 'bezoeker', function($http, $log, $filter, $scope, $window, bezoeker){

    $scope.currentLoan = {};
    $scope.currentLoan.stillToPay = 25000;
    $scope.currentLoan.period = Math.round(137.36356419173);
    $scope.currentLoan.totalprice = 34340.891047932;
    $scope.currentLoan.monthlyCosts = 250;
    $scope.currentLoan.interest = 6;
    $scope.currentLoan.showRente = 6;

    $scope.newLoan = {};
    $scope.newLoan.stillToPay = 25000;
    $scope.newLoan.period = 125;
    $scope.newLoan.totalprice = 31976.669126077;
    $scope.newLoan.monthlyCosts = 250;
    $scope.newLoan.interest = 4.5;

    $scope.otherLoan = {};

    $scope.showBesparing = false;

    $scope.defaultLoanInterest = {
        'DK' : '6',
        'CC' : '13',
        'LB' : '13',
        'PL' : '13',
        'VK' : '13',
        'RK' : '13'
    };

    $scope.leenvormOptions = [{
        label: 'Doorlopend Krediet',
        value: 'DK'
    }, {
        label: 'Persoonlijke Lening',
        value: 'PL'
    }, {
        label: 'Creditcard',
        value: 'CC'
    }, {
        label: 'Limiet op betaalrekening',
        value: 'LB'
    }, {
        label: 'Verzendhuiskrediet',
        value: 'VK'
    }, {
        label: 'Overig',
        value: 'RK'
    }
    ];

    $scope.bezoeker = bezoeker;

    $scope.calculateCurrentLoan = function() {

        var data = $scope.loans;
        var totaal = 0; //totaalbedrag aan leningen.

        for (var i = $scope.loans.length - 1; i >= 0; i--) {
            totaal += parseInt($scope.loans[i].restandschuld);
        }

        //Wanneer het totaalbedrag onder de 5000 is kan er geen besparing worden berekend.
        if(totaal < 5000) {
            return false;
        }

        bezoeker.lopendeLeningen = data;

        bezoeker.store();

        $http.post('/ajax/calculateSavings/', data).
        success(function(data, status, headers, config) {

            $scope.updateSavings(data);
            $scope.showBesparing = 'true';

            $window.setTimeout(function() {
                $('html, body').animate({
                    scrollTop: $(".loan-result-savings").offset().top - 100
                }, 500);
            }, 100);

        }).
        error(function(data, status, headers, config) {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
        });
    };

    $scope.submitLoan = function(loan, e)
    {
        e.preventDefault();

        var looptijd = loan.period;
        var maandlast = loan.monthlyCosts;
        var bedrag = loan.stillToPay;
        var parameterizedUrl = '/offerte-aanvragen/?oversluittool=true&doel=lagere-rente';

        if(loan.productvorm === 'Persoonlijke lening')
        {
            productvorm = 'Persoonlijke lening';
            looptijdUrl = Math.floor(looptijd/12) * 12;
            parameterizedUrl = parameterizedUrl+'&productvorm='+productvorm+'&looptijd='+(looptijdUrl)+'&leenbedrag='+bedrag
        }else{
            productvorm = 'Doorlopend krediet';
            parameterizedUrl = parameterizedUrl+'&productvorm='+productvorm+'&leenbedrag='+bedrag
        }

        $http.post('/session/saveUser/', {'productvorm' : productvorm, 'gewenstLeenbedrag' : bedrag, 'leenbedrag' : bedrag, 'looptijd' : looptijd, 'maandlast' : maandlast, 'bestedingsdoel' : 'Lagere rente'}).success(function(data, status, headers, config) {
            $window.location.href = parameterizedUrl;
        });
    };

    $scope.updateSavings = function(data)
    {
        $scope.currentLoan.stillToPay = data.teBetalen;
        $scope.currentLoan.period = Math.round(data.looptijd);
        $scope.currentLoan.monthlyCosts = data.maandTermijn;
        $scope.currentLoan.totalprice = data.totaalPrijs;

        $scope.newLoan.stillToPay = data.teBetalen;
        $scope.newLoan.period = Math.round(data.newRenteObject.looptijd);
        $scope.newLoan.monthlyCosts = data.newRenteObject.maandlast;
        $scope.newLoan.totalprice = data.newRenteObject.totaalPrijs;
        $scope.newLoan.interest = data.newRenteObject.rente;
        $scope.newLoan.bank = data.newRenteObject.bank;
        $scope.newLoan.productvorm = data.newRenteObject.productvorm;

        $scope.otherLoan.stillToPay = data.teBetalen;
        $scope.otherLoan.period = Math.round(data.otherLoan.looptijd);
        $scope.otherLoan.monthlyCosts = data.otherLoan.maandlast;
        $scope.otherLoan.totalprice = data.otherLoan.totaalPrijs;
        $scope.otherLoan.interest = data.otherLoan.rente;
        $scope.otherLoan.bank = data.otherLoan.bank;
        $scope.otherLoan.productvorm = data.otherLoan.productvorm;

        $scope.currentLoan.showRente = $scope.calculateCurrentRente();

    };

    $scope.loans = [];

    $scope.Loan = function(id) {
        this.id = id;
        this.leenvorm = $scope.leenvormOptions[0];
        this.restandschuld = 25000;
        this.maandtermijn = 250;
        this.rente = 6.0;
    };

    $scope.setInterest = function(loan)
    {
        loan.rente = $scope.defaultLoanInterest[loan.leenvorm.value];
    };

    $scope.calculateCurrentRente = function()
    {

        renteArray = [];

        for (var i = Object.keys($scope.loans).length - 1; i >= 0; i--) {
            renteArray.push($scope.loans[i].rente);
        }

        renteArray.sort(function(a, b){return a-b;});

        if(renteArray.length > 1 && renteArray[0] != renteArray[renteArray.length-1])
        {
            return renteArray[0].toString().replace('.', ',') + "%" + " - " + renteArray[renteArray.length -1].toString().replace('.', ',') + "%";
        }else{
            return renteArray[0].toString().replace('.', ',') + "%";
        }

    };

    $scope.addLoan = function()
    {
        var noOfLoans = Object.keys($scope.loans).length;

        var loan = new $scope.Loan(noOfLoans);

        loan.added = true;

        $scope.loans.push(loan);
    };


    $scope.deleteLoan = function(loan)
    {
        var index = $scope.loans.indexOf(loan);

        $scope.loans.splice(index,1);
    };

    $scope.getLeenvormByDefaultValue = function(defaultValue)
    {
        if(defaultValue === 'doorlopend krediet')
            return $scope.leenvormOptions[0];

        if(defaultValue === 'persoonlijke lening')
            return $scope.leenvormOptions[1];

        if(defaultValue === 'creditcard')
            return $scope.leenvormOptions[2];

        if(defaultValue === 'limiet op betaalrekening')
            return $scope.leenvormOptions[3];

        if(defaultValue === 'verzendhuiskrediet')
            return $scope.leenvormOptions[4];

        if(defaultValue === 'overig')
            return $scope.leenvormOptions[5];


        return $scope.leenvormOptions[0];
    };

    $scope.addLoan();

    /* Na het opnieuw inladen van de rentetarieven moet de styling op de selectbox opnieuw geinitieerd worden. */
    function rebuildSelect2()
    {
        $window.setTimeout(function() {
            $(".hkil select.js-select").select2({
                minimumResultsForSearch: -1,
                width: '100%',
                theme: 'pwc',
                dropdownAutoWidth: 'true'
            });
        }, 10 );
    }

    rebuildSelect2();
}]);